/* ─── main-product ─── */

(function () {
  /* Global */
  const root = document.querySelector('.main-product');
  const jsonString = root.getAttribute('data-product-variants');
  if (!root || !jsonString) return;
  const moneyFormat = root.getAttribute('data-money-format');
  const moneyFormatExample = root.getAttribute('data-money-format-example');
  const addToCart = root.querySelector('.main-product__add');
  const originalPrice = root.querySelector('.main-product-so__original-price');
  const price = root.querySelector('.main-product-so__price');
  const compare = root.querySelector('.main-product-so__compare');
  let variants = undefined;
  try {
    variants = JSON.parse(jsonString);
  } catch (err) {
    console.log(err);
  }
  if (!variants) return;

  /* Sliders */
  const thumbSwiper = new Swiper('.main-product-thumbnails', {
    spaceBetween: 10,
    slidesPerView: 7,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    slideToClickedSlide: true,
    freeMode: false,
  });

  const mainSwiper = new Swiper('.main-product-images', {
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: thumbSwiper,
    },

    on: {
      slideChange(swiper) {
        const index = swiper.activeIndex;
        const visibleThumbs = 7;
        const firstVisible = thumbSwiper.activeIndex;
        const lastVisible = thumbSwiper.activeIndex + visibleThumbs - 1;

        if (index >= lastVisible - 1) {
          thumbSwiper.slideTo(index - (visibleThumbs - 3));
        }

        if (index <= firstVisible + 1) {
          thumbSwiper.slideTo(Math.max(index - 1, 0));
        }

        root.querySelectorAll('.main-product-images .swiper-slide').forEach((slide, i) => {
          if (i === index) return;
          const video = slide.querySelector('video');
          if (video) video.pause();
        });
      },
    },
  });

  /* Video slides: simple play/pause toggle */
  root.querySelectorAll('.main-product-images__video-wrap').forEach((wrap) => {
    const video = wrap.querySelector('video');
    if (!video) return;

    wrap.addEventListener('click', () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', () => wrap.classList.add('main-product-images__video-wrap--playing'));
    video.addEventListener('pause', () => wrap.classList.remove('main-product-images__video-wrap--playing'));
  });

  /* Options */
  const options = document.querySelectorAll('.main-product-option input[type="radio"]');

  options.forEach((option) => {
    option.addEventListener('change', () => {
      const selectedOptions = getSelectedOptions();
      const selectedVariant = findSelectedVariant(selectedOptions);
      if (!selectedVariant) return;

      updateQueryParam('variant', selectedVariant.id);

      const newPrice = formatMoney(moneyFormat, moneyFormatExample, selectedVariant.price);
      const newSubscribePrice = formatMoney(moneyFormat, moneyFormatExample, selectedVariant.price * 0.7);
      if (originalPrice) originalPrice.textContent = newPrice;
      if (compare) compare.textContent = newPrice;
      if (price) price.textContent = newSubscribePrice;

      if (selectedVariant.available) {
        addToCart.disabled = false;
        addToCart.textContent = 'Add To Cart';
      } else {
        addToCart.disabled = true;
        addToCart.textContent = 'Out of stock';
      }
    });
  });

  function getSelectedOptions() {
    const selectedOptions = [null, null, null];

    const checkedRadios = document.querySelectorAll('.main-product-option input[type="radio"]:checked');

    checkedRadios.forEach((el, i) => {
      selectedOptions[i] = el.getAttribute('data-value-name');
    });

    return selectedOptions;
  }

  function findSelectedVariant(selectedOptions) {
    return variants.find((v) => {
      return (
        v.option1 === selectedOptions[0] &&
        v.option2 === selectedOptions[1] &&
        v.option3 === selectedOptions[2]
      );
    });
  }

  /* Quantity selector */
  const minusBtn = document.querySelector('.main-product-quantity__minus');
  const plusBtn = document.querySelector('.main-product-quantity__plus');
  const qtyInput = document.querySelector('.main-product-quantity__input');

  minusBtn.addEventListener('click', () => {
    let quantity = parseInt(qtyInput.value, 10) || 1;
    if (quantity > 1) {
      qtyInput.value = quantity - 1;
    }
  });

  plusBtn.addEventListener('click', () => {
    let quantity = parseInt(qtyInput.value, 10) || 1;
    qtyInput.value = quantity + 1;
  });

  /* Selling plans */
  const sellingPlanRadios = document.querySelectorAll('.main-product-so input[type="radio"]');
  const sellingPlanId = document.querySelector('#selling-plan');

  if (sellingPlanId) {
    sellingPlanRadios.forEach((radio) => {
      radio.addEventListener('change', (e) => {
        if (e.target.value === 'true') {
          sellingPlanId.name = 'selling_plan';
        } else {
          sellingPlanId.name = '';
        }
      });
    });
  }

  /* Accordions */
  const accordions = document.querySelectorAll('.main-product-accordion');
  const accordionHeaders = document.querySelectorAll('.main-product-accordion__header');
  const accordionActiveCls = 'main-product-accordion--active';

  function openAccordion(acc) {
    const body = acc.querySelector('.main-product-accordion__body');
    const inner = acc.querySelector('.main-product-accordion__body-inner');

    acc.classList.add(accordionActiveCls);

    const fullHeight = inner.scrollHeight;
    body.style.maxHeight = fullHeight + 'px';
  }

  function closeAccordion(acc) {
    const body = acc.querySelector('.main-product-accordion__body');
    acc.classList.remove(accordionActiveCls);
    body.style.maxHeight = '0px';
  }

  accordionHeaders.forEach((header) => {
    header.addEventListener('click', () => {
      const parent = header.parentElement;
      const isOpen = parent.classList.contains(accordionActiveCls);

      accordions.forEach(closeAccordion);
      if (!isOpen) openAccordion(parent);
    });
  });

  accordions.forEach((acc) => {
    if (acc.classList.contains(accordionActiveCls)) {
      openAccordion(acc);
    }
  });

  window.addEventListener('resize', () => {
    accordions.forEach((acc) => {
      if (acc.classList.contains(accordionActiveCls)) {
        const body = acc.querySelector('.main-product-accordion__body');
        const inner = acc.querySelector('.main-product-accordion__body-inner');
        body.style.maxHeight = inner.scrollHeight + 'px';
      }
    });
  });

  /* Description read more/less */
  const descriptions = document.querySelectorAll('.main-product__description');
  const descriptionActiveCls = 'main-product__description--expanded';

  descriptions.forEach((desc) => {
    const moreToggle = desc.querySelector('.main-product__description-toggle--more');
    const lessToggle = desc.querySelector('.main-product__description-toggle--less');
    const more = desc.querySelector('.main-product__description-more');

    if (!moreToggle || !more) {
      if (moreToggle) moreToggle.remove();
      if (lessToggle) lessToggle.remove();
      return;
    }

    moreToggle.addEventListener('click', () => {
      desc.classList.add(descriptionActiveCls);
      more.style.maxHeight = more.scrollHeight + 'px';
    });

    if (lessToggle) {
      lessToggle.addEventListener('click', () => {
        more.style.maxHeight = '';
        more.addEventListener(
          'transitionend',
          (e) => {
            if (e.propertyName === 'max-height') desc.classList.remove(descriptionActiveCls);
          },
          { once: true }
        );
      });
    }
  });

  window.addEventListener('resize', () => {
    descriptions.forEach((desc) => {
      if (!desc.classList.contains(descriptionActiveCls)) return;
      const more = desc.querySelector('.main-product__description-more');
      if (more) more.style.maxHeight = more.scrollHeight + 'px';
    });
  });
})();

/* ─── wave-text ─── */

document.addEventListener('DOMContentLoaded', function () {
  const textPath = document.querySelector('#waveText');
  const path = document.querySelector('#wavePath');
  const pathLength = path.getTotalLength();

  let offset = 0;
  const speed = 0.5;

  function animate() {
    offset -= speed;

    if (Math.abs(offset) > pathLength) {
      offset = 0;
    }

    textPath.setAttribute('startOffset', offset);

    requestAnimationFrame(animate);
  }

  animate();
});

/* ─── matters ─── */

(function () {
  const accordions = document.querySelectorAll('.matters-accordion');
  const headers = document.querySelectorAll('.matters-accordion__header');
  const activeClass = 'matters-accordion--active';

  function openAccordion(acc) {
    const body = acc.querySelector('.matters-accordion__body');
    const inner = acc.querySelector('.matters-accordion__body-inner');
    acc.classList.add(activeClass);
    body.style.maxHeight = inner.scrollHeight + 'px';
  }

  function closeAccordion(acc) {
    const body = acc.querySelector('.matters-accordion__body');
    acc.classList.remove(activeClass);
    body.style.maxHeight = '0px';
  }

  headers.forEach((header) => {
    header.addEventListener('click', () => {
      const parent = header.parentElement;
      const isOpen = parent.classList.contains(activeClass);

      accordions.forEach(closeAccordion);

      if (!isOpen) {
        openAccordion(parent);
      }
    });
  });

  accordions.forEach((acc) => {
    if (acc.classList.contains(activeClass)) {
      openAccordion(acc);
    }
  });

  window.addEventListener('resize', () => {
    accordions.forEach((acc) => {
      if (acc.classList.contains(activeClass)) {
        const body = acc.querySelector('.matters-accordion__body');
        const inner = acc.querySelector('.matters-accordion__body-inner');
        body.style.maxHeight = inner.scrollHeight + 'px';
      }
    });
  });
})();

/* ─── faqs ─── */

(function () {
  const accordions = document.querySelectorAll('.faq-question');
  const headers = document.querySelectorAll('.faq-question__header');
  const activeClass = 'faq-question--active';

  function openAccordion(acc) {
    const body = acc.querySelector('.faq-question__body');
    const inner = acc.querySelector('.faq-question__body-inner');
    acc.classList.add(activeClass);
    body.style.maxHeight = inner.scrollHeight + 'px';
  }

  function closeAccordion(acc) {
    const body = acc.querySelector('.faq-question__body');
    acc.classList.remove(activeClass);
    body.style.maxHeight = '0px';
  }

  headers.forEach((header) => {
    header.addEventListener('click', () => {
      const parent = header.parentElement;
      const isOpen = parent.classList.contains(activeClass);

      accordions.forEach(closeAccordion);

      if (!isOpen) {
        openAccordion(parent);
      }
    });
  });

  accordions.forEach((acc) => {
    if (acc.classList.contains(activeClass)) {
      openAccordion(acc);
    }
  });

  window.addEventListener('resize', () => {
    accordions.forEach((acc) => {
      if (acc.classList.contains(activeClass)) {
        const body = acc.querySelector('.faq-question__body');
        const inner = acc.querySelector('.faq-question__body-inner');
        body.style.maxHeight = inner.scrollHeight + 'px';
      }
    });
  });
})();
